export default __webpack_public_path__ + "static/media/028-leaf.7f17dcc1.svg";